export const CHECKOUT_ANCHOR_ID = 'comprar';

export function scrollToCheckout() {
  document.getElementById(CHECKOUT_ANCHOR_ID)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
